/**
 * CDN 工具函数
 *
 * @serverOnly false - 可在客户端和服务端使用
 */

/**
 * CDN 配置接口
 */
export interface CdnConfig {
  /** 是否启用 CDN */
  NEXT_PUBLIC_DEPLOY_CDN: string
  /** CDN 主机地址 */
  NEXT_PUBLIC_DEPLOY_HOST: string
  /** CDN 版本号 */
  NEXT_PUBLIC_DEPLOY_VERSION: string
  /** CDN 后缀 */
  NEXT_PUBLIC_DEPLOY_SUFFIX: string
}

/**
 * 获取 CDN 地址
 * @param config - CDN 配置对象
 * @returns CDN 地址字符串
 */
export const getCdnUrl = (config: CdnConfig): string => {
  const { NEXT_PUBLIC_DEPLOY_CDN, NEXT_PUBLIC_DEPLOY_HOST, NEXT_PUBLIC_DEPLOY_VERSION, NEXT_PUBLIC_DEPLOY_SUFFIX } =
    config

  return NEXT_PUBLIC_DEPLOY_CDN === "true"
    ? `${NEXT_PUBLIC_DEPLOY_HOST}/${NEXT_PUBLIC_DEPLOY_VERSION}/public`
    : NEXT_PUBLIC_DEPLOY_SUFFIX
}

/**
 * 为图片 URL 按需追加 imageView2 参数。
 * 若 URL 中已包含 imageView2，则直接返回原 URL，否则在末尾拼接 ? 或 & + params。
 *
 * @param url 原始图片 URL
 * @param params 要追加的参数字符串（如 imageView2/1/w/600/h/338/q/100/format/webp）
 * @returns 处理后的 URL
 */
export function appendImageView2Params(url: string, params: string): string {
  if (url.includes("imageView2")) return url
  const trimmedParams = params.trim()
  if (!trimmedParams) return url
  const separator = url.includes("?") ? "&" : "?"
  return `${url}${separator}${trimmedParams}`
}
